import * as React from 'react';
import * as _ from 'lodash';
import { Row, Button, ButtonToolbar } from 'react-bootstrap';

import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../common/formatters';

export const defaultInputProps = {
    colInputXs: 6,
    colLabelXs: 6,
};

export const ClientDetailFormSection =  ({ title, className = '', ...rest }) => {
    // copied from css .inventory-detail-form-section
    return (        
        // <div className={`association-detail-form-section ${className}`}>
        <div className={`inventory-detail-form-section ${className}`}>
            <KendoWrappers.KendoFormSection title={title}>
                {rest.children}
            </KendoWrappers.KendoFormSection>
        </div>
    );
};

export const ClientDetailFormSectionSpacing =  (rest) => {
    return (
        // <div className={`association-detail-form-section-spacing`} />
        <div className={`inventory-detail-form-section-spacing`} />
    );
};

export const NameOptionRenderer = ({ focusedOption, focusedOptionIndex, focusOption, key, labelKey, option, optionIndex, options, selectValue, style, valueArray, valueKey, ...nameOptionsRest }) => {
    // console.log('nameOptionsRest', nameOptionsRest);
    let classNames = ['name-option'];

    if (option.type === 'header') {
      classNames.push('name-header');

      return (
        <div
          className={classNames.join(' ')}
          key={key}
          style={style}
        >
          {option[labelKey]}
        </div>);
    } else {
      if (option === focusedOption) {
        classNames.push('name-focused-option');
      }

      if (valueArray.indexOf(option) >= 0) {
        classNames.push('name-option-selected');
      }

      return (
        <div
          className={classNames.join(' ')}
          key={key}
          onClick={() => selectValue(option)}
          onMouseEnter={() => focusOption(option)}
          style={style}
        >
          {option[labelKey]}
        </div>
      );
    }
};

export const InventoryNote = ({ authorText, dateText, children, onClickDelete, onClickSave, deleteButtonVisible = true, saveButtonVisible = false, ...props}) => {
    return (
        <div className="inventory-note-container form-section">
            <div className="inventory-note-header">
                <Row>
                    <Col xs={9}>
                        <span className="inventory-note-author">{authorText}</span>
                        <span className="inventory-note-created">{dateText}</span>
                    </Col>
                    <Col xs={3} className="text-right">
                        {(saveButtonVisible) ? (
                            <Button bsStyle="success" bsSize="xs" onClick={(e) => { onClickSave(e); }}><i className="fa fa-save" /></Button>
                        ) : (<div />)}

                        {(deleteButtonVisible) ? (
                            <Button bsStyle="danger" bsSize="xs" onClick={onClickDelete}><i className="fa fa-trash-o" /></Button>
                        ) : (<div />)}
                    </Col>
                </Row>
            </div>
            <div className="inventory-note-text">
                {children}
            </div>
        </div>
    );
};

export const InventoryNoteRow = ({ children, ...props}) => {
    return (
        <Row>
            <Col xs={12}>
                {children}
            </Col>
        </Row>
    );
};

export const ClientContact = ({ contactName, contact, children, onClickDelete, onClickEdit, onClickSave, deleteButtonVisible = true, editButtonVisible = true, saveButtonVisible = false, ...props }) => {
    return (
        <div className="inventory-note-container form-section">
            <div className="inventory-note-header">
                <Row>
                    <Col xs={9}>
                        <span className="inventory-note-author">{contactName}</span>
                        <span className="inventory-note-created" />
                    </Col>
                    <Col xs={3} className="text-right">
                        <ButtonToolbar>
                            {(editButtonVisible) ? (
                                <Button bsStyle="info" bsSize="xs" onClick={(e) => { onClickEdit(e); }}><i className="fa fa-edit" /> Edit Contact</Button>
                            ) : (<div />)}

                            {(deleteButtonVisible) ? (
                                <Button bsStyle="danger" bsSize="xs" onClick={onClickDelete}><i className="fa fa-trash-o" /> Delete Contact</Button>
                            ) : (<div />)}
                        </ButtonToolbar>
                    </Col>
                </Row>
            </div>
            <div className="inventory-note-text">
                {children}
            </div>
        </div>
    );
};

export const ClientContacts = ({ name, clientContacts, onClickDelete, onClickEdit, onClickSave, deleteButtonVisible = true, editButtonVisible = true, saveButtonVisible = false, ...rest }) => {
    if (!_.size(clientContacts)) { return (<div/>); }

    let result = _.map(clientContacts, (o, i) => {
        // const objId = _.get(o, 'objectId');
        const objId = _.get(o, 'contactId');
        return (            
            <InventoryNoteRow key={`client-contacts-row-client-contacts-${i}`}>
                <ClientContact
                    contactName={Formatters.composeClientContactFormal(o)}
                    contact={o}                    
                    onClickDelete={(e) => { onClickDelete({ target: { value: objId, contactType: 'clientContact', type: 'delete-button', name: name }}, o); }}
                    onClickEdit={(e) => { onClickEdit({ target: { value: objId, contactType: 'clientContact', type: 'edit-button', name: name }}, o); }}
                    onClickSave={(e) => { onClickSave(e); }}
                    deleteButtonVisible={deleteButtonVisible}
                    editButtonVisible={editButtonVisible}
                    saveButtonVisible={saveButtonVisible}
                >                    
                    <div>{Formatters.composeClientContactFormal(o)}</div>
                    <div>{Formatters.formatPhoneNumber(Formatters.getStr(o, 'phone'))}</div>
                    <div>{Formatters.getStr(o, 'email')}</div>
                    {/* <br />
                    <div>NOTES {Formatters.getStr(o, 'notes[0].note')}</div> */}
                </ClientContact>
            </InventoryNoteRow>
        );
    });

    return (
        <div>
            {result}
        </div>
    );
};

export const ClientNotes = ({ name, clientNotes, onClickDelete, onClickSave, deleteButtonVisible = true, saveButtonVisible = false, ...rest }) => {
    if (!_.size(clientNotes)) { return (<div/>); }

    let result = _.map(clientNotes, (o, i) => {
        const objId = _.get(o, 'objectId');
        return (
            <InventoryNoteRow key={`client-note-row-client-notes-${i}`}>
                <InventoryNote
                    authorText={`${Formatters.getStr(o, 'author.firstName')} ${Formatters.getStr(o, 'author.lastName')}`}
                    dateText={Formatters.formatDateLongDate(_.get(o, 'created', new Date()))}
                    onClickDelete={(e) => { onClickDelete({ target: { value: objId, noteType: 'client', type: 'delete-button', name: name }}, o); }}
                    onClickSave={(e) => { onClickSave(e); }}
                    deleteButtonVisible={deleteButtonVisible}
                    saveButtonVisible={saveButtonVisible}
                >
                    <div>{Formatters.getStr(o, 'notes')}</div>
                </InventoryNote>
            </InventoryNoteRow>
        );
    });

    return (
        <div>
            {result}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/client/detail-form/common.tsx